import parseV0TemplateUrl from "./parseV0TemplateUrl";
export default parseV0TemplateUrl;
